import React, { useState, useEffect } from 'react';
import { useAuthStore } from '../../stores/useAuthStore'; // 🟢 1. Usamos el store correcto
import { useDataStore } from '../../stores/useDataStore'; // 🟢 2. Importamos el store de datos
import CommentItem from '../modals/CommentItem'; // Asegúrate de que este import esté presente
import toast from 'react-hot-toast';
import { getMediaUrl } from '../../utils/imageUtils';
const avatarFallback = '/images/avatar/DefaultProfile.jpg';

// Helper function to format time
const formatTimeAgo = (date) => {
  if (!date) return '';
  const seconds = Math.floor((new Date() - new Date(date)) / 1000);
  let interval = seconds / 31536000;
  if (interval > 1) return `hace ${Math.floor(interval)} años`;
  interval = seconds / 2592000;
  if (interval > 1) return `hace ${Math.floor(interval)} meses`;
  interval = seconds / 86400;
  if (interval > 1) return `hace ${Math.floor(interval)} días`;
  interval = seconds / 3600;
  if (interval > 1) return `hace ${Math.floor(interval)} horas`;
  interval = seconds / 60;
  if (interval > 1) return `hace ${Math.floor(interval)} minutos`;
  return 'hace unos segundos';
};

const CommentModal = ({ isOpen, onClose, modalData }) => {
  const { currentUser } = useAuthStore(); // 🟢 2. Obtenemos el usuario del store correcto
  const { postId, onComment } = modalData || {};

  // 🟢 3. Obtenemos el estado y las acciones del feedStore consolidado
  const post = useDataStore((state) => {
    const allPosts = [...state.feed.posts, ...Object.values(state.feed.wallPosts).flat()];
    const uniquePosts = Array.from(new Map(allPosts.map((p) => [p._id, p])).values());
    return uniquePosts.find((p) => p._id === postId);
  });
  const addComment = useDataStore((state) => state.addComment);
  const likeComment = useDataStore((state) => state.likeComment);
  const addReplyToComment = useDataStore((state) => state.addReplyToComment);

  const [newCommentText, setNewCommentText] = useState('');
  const [replyingTo, setReplyingTo] = useState(null); // Estado local para manejar a qué comentario se responde

  // Limpia el estado cuando el modal se cierra
  useEffect(() => {
    if (!isOpen) {
      setNewCommentText('');
      setReplyingTo(null);
    }
  }, [isOpen]);

  if (!isOpen || !post) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newCommentText.trim()) {
      // 🟢 4. Usamos la acción del store directamente
      const result = await addComment(postId, newCommentText);
      if (!result?.success) {
        toast.error('No se pudo añadir el comentario.');
        return;
      }
      setNewCommentText('');
    }
  };

  return (
    <div
      className="fixed inset-0 bg-gray-600/75 dark:bg-black/75 flex justify-center items-center z-[10000]" // 🟢 CORRECCIÓN: Aumentamos el z-index
      onClick={onClose}
    >
      <div
        className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl max-w-lg w-full m-4 relative max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
        >
          <i className="fas fa-times"></i>
        </button>
        <h2 className="text-xl font-bold mb-4 text-gray-800 dark:text-gray-100">Comentarios</h2>

        <div className="border-b border-gray-200 dark:border-gray-700 pb-4 mb-4">
          <div className="flex items-start space-x-3">
            <img
              src={post.author?.avatar ? getMediaUrl(post.author.avatar) : avatarFallback}
              alt={post.author?.username}
              className={`w-10 h-10 rounded-full object-cover ${post.author?.rank === 'senator' || post.author?.tier === 'senador' ? 'gold-aura' : ''}`}
            />
            <div>
              <h3 className="font-semibold text-gray-800 dark:text-gray-100">{post.author?.username}</h3>
              <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">{post.content}</p>
              {post.images && post.images[0] && (
                <img
                  src={getMediaUrl(post.images[0])}
                  alt="Post"
                  className="mt-2 rounded-lg w-full max-h-64 object-cover"
                />
              )}
            </div>
          </div>
        </div>

        <div className="space-y-4 mb-4">
          {post.comments && post.comments.length > 0 ? (
            post.comments
              .slice()
              .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
              .slice(0, 8)
              .map(
                (
                  comment // 🟢 LÍMITE: Mostramos hasta 8 comentarios.
                ) => (
                  <CommentItem
                    key={comment._id}
                    comment={comment}
                    onLike={() => likeComment(postId, comment._id)}
                    onReply={(commentId, text) => addReplyToComment(postId, commentId, text)}
                    isReplying={replyingTo === comment._id}
                    setReplyingTo={setReplyingTo}
                  />
                )
              ) // Ordenamos los comentarios por fecha
          ) : (
            <p className="text-center text-gray-500 dark:text-gray-400">
              Sé el primero en comentar.
            </p>
          )}
        </div>

        <form
          onSubmit={handleSubmit}
          className="flex items-center space-x-2 border-t border-gray-200 dark:border-gray-700 pt-4"
        >
          {/* 3. Añadimos el avatar del usuario actual */}
          <img
            src={currentUser?.avatar ? getMediaUrl(currentUser.avatar) : avatarFallback}
            alt="Tu avatar"
            className={`w-8 h-8 rounded-full object-cover ${currentUser?.rank === 'senator' || currentUser?.tier === 'senador' ? 'gold-aura' : ''}`}
          />
          <textarea
            className="flex-1 p-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 rounded-full resize-none"
            placeholder="Escribe tu comentario..."
            rows="1" // Se ajustará automáticamente
            value={newCommentText}
            onChange={(e) => setNewCommentText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) handleSubmit(e);
            }}
          ></textarea>
          <button
            type="submit"
            className="bg-blue-500 text-white font-bold py-2 px-4 rounded-full hover:bg-blue-600"
          >
            Publicar
          </button>
        </form>
      </div>
    </div>
  );
};

export default CommentModal;
